export class EmailInput {
  emailAddress: string;
  isValid: boolean;
}
